import React, { ReactNode } from "react";
import { Box } from '@mui/material';
interface LoadingSectionProps {
  loading: boolean;
  children: ReactNode;
}

const LoadingSection: React.FC<LoadingSectionProps> = ({ loading, children }) => {


    return <React.Fragment key={`${loading}`}>{children}</React.Fragment>;
};

export default LoadingSection;
